import { ColumnViewModel } from '../../shared/column-types';

export const GENES_GDA_EVIDENCE: ColumnViewModel = {
  columns: [
    'geneSymbol',
    'diseaseName',
    'diseaseUMLSCUI',
    'geneNcbiID',
    'geneEnsemblIDs',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'geneDPI',
    'geneDSI',
    'score',
    'sourceScore',
    'associationType',
    'ancestry_name',
    'disease_model_in_doc',
    'sex_in_doc',
    'source',
    'sentenceHTML',
    'chemsInSentence',
    'chemIDs',
    'pmid',
    'pmYear',
    'journal_abbrv',
    'diseaseType',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'geneNcbiType',
    'pathwayName',
    'pathwayID',
    'chemical_effect',
    'reference',
    'reference_type',
    'nct_title',
    'pmed_title',
    'nct_phase',
    'association',
    'citation_count',
    'icite_apt',
  ],
  defaultVisible: [
    'diseaseName',
    'geneDPI',
    'geneDSI',
    'score',
    'sourceScore',
    'associationType',
    'ancestry_name',
    'disease_model_in_doc',
    'sex_in_doc',
    'sentenceHTML',
    'chemsInSentence',
    'pmid',
    'pmYear',
    'journal_abbrv',
    'reference',
    'reference_type',
    'nct_title',
    'pmed_title',
  ],
};